import React, { useState } from 'react'
import './styles.scss'
import { AutofitIFrame } from '@ta-interaktiv/react-autofit-iframe'
import Toggle from 'react-toggle'
import DataWrapperChart from 'components/DataWrapperChart'

export const HospChart = () => {
  const [isCurrentWave, setCurrentWave] = useState<boolean>(true)

  return (
    <div className='graphic chart' id='hospToggle'>
      <h3>Hospitalisierte in der Schweiz nach Altersgruppen</h3>
      <div className='toggleWrapper'>
        <div className='center'>
          <div className={'label ' + (!isCurrentWave ? '' : 'off')}>Total</div>
          <div className='toggleContainer'>
            <Toggle
              defaultChecked={isCurrentWave}
              icons={false}
              onChange={() => {
                setCurrentWave(!isCurrentWave)
              }}
            />
          </div>
          <div className={'label right ' + (isCurrentWave ? '' : 'off')}>
            Omikron-Welle (ab&nbsp;3.&nbsp;Jan.&nbsp;22)
          </div>
        </div>
      </div>

      <div
        className='switchMap'
        style={{
          position: 'relative',
          display: 'block',
          marginBottom: '1.5em'
        }}
      >
        <div
          style={{
            opacity: !isCurrentWave ? '0' : '1.0',
            position: 'absolute',
            top: '0',
            zIndex: !isCurrentWave ? 1 : 99,
            width: '100%'
          }}
        >
          <DataWrapperChart chartId='IFLAG' height={600} />
        </div>
        <div
          style={{
            opacity: isCurrentWave ? '0' : '1.0',
            position: 'relative',
            top: '0',
            zIndex: !isCurrentWave ? 99 : 1,
            width: '100%'
          }}
        >
          <DataWrapperChart chartId='bio7V' height={600} />
        </div>
      </div>
    </div>
  )
}
